import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISafetyCase,
  ISafetyCaseUpdateUpsert,
} from '../../interfaces'

const getUpdateSafetyCaseMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/sms/SafetyCases`,
})

const useUpdateSafetyCaseMutation: IUseUpdateMutation<ISafetyCase, ISafetyCaseUpdateUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getUpdateSafetyCaseMutationRequest(params), [params])

  const updateSafetyCase: IUpdateFn<ISafetyCaseUpdateUpsert, ISafetyCase> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCase, Error, ISafetyCaseUpdateUpsert>({
    mutationFn: updateSafetyCase,
    ...options,
  })

  return response
}

export default useUpdateSafetyCaseMutation
